import { render, staticRenderFns } from "./SmartListPage.vue?vue&type=template&id=40cf981a"
import script from "./SmartListPage.vue?vue&type=script&lang=js"
export * from "./SmartListPage.vue?vue&type=script&lang=js"
import style0 from "./SmartListPage.vue?vue&type=style&index=0&id=40cf981a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports